import { getCampaignApiUrl } from './campaign-api-client';

const parseResponse = async <T>(response: Response): Promise<T> => {
  const body = (await response.json().catch(() => ({}))) as T & { message?: string };
  if (!response.ok) {
    throw new Error(body?.message || `Public request failed (${response.status}).`);
  }
  return body;
};

export const publicCampaignApiGet = async <T>(
  path: string,
  query: Record<string, string>
): Promise<T> => {
  const params = new URLSearchParams(query);
  const response = await fetch(`${getCampaignApiUrl(path)}?${params.toString()}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
  });
  return parseResponse<T>(response);
};

export const publicCampaignApiPost = async <T>(path: string, body: unknown): Promise<T> => {
  const response = await fetch(getCampaignApiUrl(path), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
  });
  return parseResponse<T>(response);
};
